'use client';

import { ReactNode } from 'react';
import * as styles from './order-complete-hero.css';

export interface OrderCompleteHeroProps {
  /** Pill rendered above the greeting (e.g. <StatusPill ...>). */
  pill?: ReactNode;
  /** First-name-aware salutation. Caller supplies the full string. */
  greeting: string;
  /**
   * Optional description rendered below the greeting (only visible on the Pickup
   * hero, where the long copy lives inside the hero per design).
   */
  description?: string;
}

/**
 * Green hero banner shared by all three order-complete states. The pill, greeting
 * and optional description are stacked vertically and left-aligned.
 */
export const OrderCompleteHero = ({ pill, greeting, description }: OrderCompleteHeroProps) => (
  <section className={styles.hero} data-id="order-complete-hero">
    {pill ? <div>{pill}</div> : null}
    <h1 className={styles.greeting} data-id="order-complete-greeting">
      {greeting}
    </h1>
    {description ? (
      <p className={styles.description} data-id="order-complete-description">
        {description}
      </p>
    ) : null}
  </section>
);
